(function () {
  if (window.trConversionLoaded) return;
  window.trConversionLoaded = true;
  function init(root) {
    (root || document).querySelectorAll('.tr-producto').forEach(function (section) {
      if (section.dataset.trConversion) return;
      section.dataset.trConversion = '1';
      var model = section.querySelector('model-viewer[data-src]');
      function loadModel() {
        if (!model || model.hasAttribute('src')) return;
        model.setAttribute('src', model.dataset.src);
        if (!document.querySelector('script[data-tr-model-library]') && !customElements.get('model-viewer')) {
          var script = document.createElement('script');
          script.type = 'module';
          script.src = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@4.0.0/dist/model-viewer.min.js';
          script.dataset.trModelLibrary = '1';
          document.head.appendChild(script);
        }
      }
      if (model) model.addEventListener('load', function () {
        if (!model.model) return;
        model.model.materials.forEach(function (material) {
          material.pbrMetallicRoughness.setMetallicFactor(0);
          material.pbrMetallicRoughness.setRoughnessFactor(0.8);
        });
      });
      var modelButton = section.querySelector('[data-tr-3d]');
      if (modelButton) modelButton.addEventListener('click', loadModel);
      if (model && !model.closest('.tr-galeria__visor').hidden) loadModel();
      var bar = section.querySelector('[data-tr-fixed]');
      var form = section.querySelector('form.tr-compra__formulario');
      if (!bar || !form) return;
      var original = form.querySelector('button[name="add"]');
      var fixed = bar.querySelector('[data-tr-fixed-add]');
      var price = bar.querySelector('[data-tr-fixed-price]');
      var pack = bar.querySelector('[data-tr-fixed-pack]');
      var media = window.matchMedia('(max-width: 749px)');
      function sync() {
        price.textContent = section.querySelector('.tr-precio').textContent;
        var selected = form.querySelector('.tr-packs input:checked');
        pack.textContent = selected ? selected.value : '';
        fixed.disabled = original.disabled;
        fixed.textContent = original.textContent.trim();
      }
      function visibility() {
        var rect = original.getBoundingClientRect();
        var visible = rect.top < window.innerHeight && rect.bottom > 0;
        bar.hidden = !media.matches || visible;
        document.body.classList.toggle('tr-has-fixed-buy', !bar.hidden);
      }
      fixed.addEventListener('click', function () {
        if (!original.disabled) form.requestSubmit(original);
      });
      form.addEventListener('change', function () { requestAnimationFrame(sync); });
      new MutationObserver(sync).observe(original, { attributes: true, childList: true, subtree: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(visibility).observe(original);
      media.addEventListener('change', visibility);
      window.addEventListener('resize', visibility, { passive: true });
      sync(); visibility();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
